<template>
  <div class="layout-options">
    <div>
      <FormLabel
        input-id="people-input-mobile"
        class="sr-only"
      >
        Guests
      </FormLabel>
      <TextField
        ref="people"
        id="people-input-mobile"
        type="number"
        inputmode="numeric"
        pattern="\d*"
        class="mb-6 sm:mb-4 font-normal"
        placeholder="Number of people"
        :model-value="form.people"
        :icon="PeopleIcon"
        :min="0"
        :errors="peopleNumberError"
        @update:modelValue="$emit('change', 'people', $event)"
        @keydown="e => ['e', 'E', '+', '-', '.', ','].includes(e.key) && e.preventDefault()"
      />
    </div>

    <div class="sr-only">
      <FormLabel is-optional>
        Layout
      </FormLabel>
    </div>

    <ButtonGroup class="h-10">
      <button
        class="w-2/5"
        :class="{'is-active': isStandingLayout }"
        @click="clickOption(standingLayoutKey)"
      >
        <TagIcon
          :icon="StandingIcon"
          class="mr-2"
          :color="isStandingLayout ? 'mono-white' : 'mono-black'"
        />
        Standing
      </button>

      <button
        class="w-2/5"
        :class="{'is-active': isSeatingLayout }"
        @click="clickOption(sittingLayoutKey)"
      >
        <TagIcon
          :icon="ChairIcon"
          class="mr-2"
          :color="isSeatingLayout ? 'mono-white' : 'mono-black'"
        />
        {{ seatingLayoutName }}
      </button>

      <Popover
        v-model="isLayoutPopupOpen"
        class="w-1/5"
        position="bottom-right"
        :content-style="{ width: '500%', padding: '16px 0' }"
      >
        <template #action>
          <IconButton class="h-full w-full layout-focus rounded-r-lg" :is-rounded="false">
            <TagIcon
              :icon="ChevronDownIcon"
              color="mono-black"
              class="h-4 w-4"
            />
          </IconButton>
        </template>

        <LayoutPopup
          :room-layout="form.roomLayout"
          @change="selectLayout"
          @click.stop
        />
      </Popover>
    </ButtonGroup>
  </div>
</template>

<script>
import ChevronDownIcon from '@tagvenue/icons/24/bold/arrows/chevron-down.svg';
import ChairIcon from '@tagvenue/icons/24/bold/education/sitting-chair.svg';
import StandingIcon from '@tagvenue/icons/24/bold/users/user-standing.svg';
import PeopleIcon from '@tagvenue/icons/24/line/users/users-03.svg';
import { markRaw } from 'vue';
import { mapState } from 'vuex';

import TagIcon from '@/components/TagIcon.vue';
import IconButton from '@/components/Ui/Buttons/IconButton.vue';
import FormLabel from '@/components/Ui/Forms/FormLabel.vue';
import TextField from '@/components/Ui/Forms/TextField.vue';
import Popover from '@/components/Ui/Popover.vue';
import ButtonGroup from '@/modules/public/search/components/SearchFilters/components/ButtonGroup.vue';

import layoutNames from './layoutNames.json';
import LayoutPopup from './LayoutPopup.vue';

export default {
  name: 'LayoutOptions',
  components: { ButtonGroup, LayoutPopup, TagIcon, IconButton, Popover, FormLabel, TextField },
  props: {
    form: {
      type: Object,
      default: () => ({
        people: null,
        roomLayout: null,
      }),
    },
  },
  data() {
    return {
      ChevronDownIcon: markRaw(ChevronDownIcon),
      ChairIcon: markRaw(ChairIcon),
      StandingIcon: markRaw(StandingIcon),
      PeopleIcon: markRaw(PeopleIcon),
      isLayoutPopupOpen: false,
    };
  },
  computed: {
    ...mapState([
      'sittingLayoutKey',
      'standingLayoutKey',
    ]),
    peopleNumberError() {
      return this.form.people ? [] : ['Enter number of people to narrow results'];
    },
    isStandingLayout() {
      return this.form.roomLayout === this.standingLayoutKey;
    },
    isSeatingLayout() {
      return this.form.roomLayout && !this.isStandingLayout;
    },
    seatingLayoutName() {
      if (this.isSeatingLayout) {
        return layoutNames[`${this.form.roomLayout}`];
      }
      return layoutNames[`${this.sittingLayoutKey}`];
    },
  },
  methods: {
    clickOption(option) {
      let value = option;
      if (this.form.roomLayout === value) {
        value = null;
      }
      this.$emit('change', 'roomLayout', value);
    },
    selectLayout(event) {
      this.isLayoutPopupOpen = false;
      this.$emit('change', 'roomLayout', event);
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //   setTimeout(() => { // wait as element will be rendered, to not break popover position on iOS
    //     this.$refs.people.$el.querySelector('input').focus();
    //   }, 250);
    // });
  },
};
</script>
